// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-dialog-container .mat-mdc-form-field-hint {
  color: #e23636 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/dialogs/confirm-dialog/confirm-dialog.component.scss"],"names":[],"mappings":"AAGC;EACC,yBAAA;AAFF","sourcesContent":["@import '../styles/colors';\n\n.confirm-dialog-container {\n\t.mat-mdc-form-field-hint {\n\t\tcolor: $primary-danger !important;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
